import "aos/dist/aos.css";
import { useState } from "react";
import { ExternalLink } from "lucide-react";

const ContactMap = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    state: "",
    projectGoals: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      if (!/^\d{0,10}$/.test(value)) return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, state, projectGoals } = formData;

    if (!name || !email || !phone || !state || !projectGoals) {
      alert("Please fill all the fields before sending.");
      return;
    }

    const message = `
New Contact Request From EduLynks
---------------------------------
Name: ${name}
Email: ${email}
Phone: ${phone}
State: ${state}
Message: ${projectGoals}
    `;

    const encodedMessage = encodeURIComponent(message.trim());
    const whatsappNumber = "917994670962";

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodedMessage}`,
      "_blank",
    );
  };

  return (
    <section className="px-[5%]">
      <div id="contactservice" className="max-w-7xl mx-auto my-16">
        <div
          className="bg-gray-800 rounded-3xl p-6 md:p-10 shadow-[inset_4px_4px_10px_rgba(255,255,255,0.1),inset_-4px_-4px_10px_rgba(0,0,0,0.1),8px_8px_20px_rgba(0,0,0,0.2),-4px_-4px_15px_rgba(255,255,255,0.1)] transition-all duration-500 hover:scale-[1.02]"
          data-aos="fade-up"
        >
          <h2
            className="text-3xl md:text-4xl font-bold text-white mb-12 text-center"
            data-aos="fade-up"
          >
            Contact Us
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-16">
            <div className="w-full h-80 lg:h-[450px] rounded-xl overflow-hidden shadow-lg">
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255348.37250196154!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2626ef57888cfff9%3A0xde5ad59412efcd71!2sEduLynks!5e0!3m2!1sen!2sin!4v1762248795969!5m2!1sen!2sin"
                width="100%"
                height="100%"
                className="border-0"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

            <div className="space-y-6">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label className="text-white text-sm font-medium">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your name"
                      className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white focus:outline-none"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-white text-sm font-medium">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter your email"
                      className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white focus:outline-none"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label className="text-white text-sm font-medium">
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Enter your phone number"
                      className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white focus:outline-none"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-white text-sm font-medium">
                      State
                    </label>
                    <input
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      placeholder="Enter your state"
                      className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white focus:outline-none"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-white text-sm font-medium">
                    Project Goals
                  </label>
                  <textarea
                    name="projectGoals"
                    value={formData.projectGoals}
                    onChange={handleInputChange}
                    placeholder="Write your project goals..."
                    rows={4}
                    className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white resize-none focus:outline-none"
                  />
                </div>

                <div className="pt-4">
                  <button
                    type="submit"
                    className="btn1 group inline-flex items-center gap-3 text-white bg-[#00cec9] px-6 py-3 rounded-xl hover:bg-[#00b8b3] transition"
                  >
                    <span className="font-medium">Send to WhatsApp</span>
                    <ExternalLink className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMap;
